import { animate, animateChild, query, style, transition, trigger } from '@angular/animations';

export const formsAnimations =
  trigger('formsAnimations', [
    transition(':enter', [
      style({ opacity: 0 }),
      animate(150, style({ opacity: 1 }))
    ])
  ]);